import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import FocusLock from 'react-focus-lock';
import Modal from '../Modal';
import Button from '../Button';
import messages from './messages';
import './styles.css';

class CollegeEventsFilterFormCancelMessage extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    onContinue: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
  };

  render() {
    const title = this.props.intl.formatMessage(messages.cancelTitle);
    const subtitle = this.props.intl.formatMessage(messages.cancelSubtitle);
    return (
      <Modal style={{ marginTop: 0 }} data-cy="create-filter-cancel-modal" open>
        <Modal.Content styleName="filter-modal-content">
          <FocusLock autoFocus>
            <div>
              <div styleName="cancel-info" role="alert" aria-label={`${title}, ${subtitle}`}>
                <div styleName="cancel-title"><FormattedMessage {...messages.cancelTitle} /></div>
                <div styleName="cancel-subtitle"><FormattedMessage {...messages.cancelSubtitle} /></div>
              </div>
              <div styleName="row border" />
              <div styleName="cancel-buttons">
                <Button
                  data-cy="create-filter-cancel-modal-reject-button"
                  type="button"
                  styleName="reject-cancel-button"
                  onClick={this.props.onContinue}
                >
                  <FormattedMessage {...messages.cancelRejectButton} />
                </Button>
                <Button
                  data-cy="create-filter-cancel-modal-confirm-button"
                  type="button"
                  primary
                  onClick={this.props.onCancel}
                >
                  <FormattedMessage {...messages.cancelConfirmButton} />
                </Button>
              </div>
            </div>
          </FocusLock>
        </Modal.Content>
      </Modal>
    );
  }
}

export default injectIntl(CollegeEventsFilterFormCancelMessage);
